// ------------------------------------------------------------
// Payment Status
// ------------------------------------------------------------

export enum PaymentStatus {
  Pending = "Pending",
  Paid = "Paid",
  Failed = "Failed",
  Expired = "Expired",
}

// ------------------------------------------------------------
// Transaction Types
// ------------------------------------------------------------

export enum PaymentTransactionType {
  OrderPayment = "OrderPayment",
  WalletTopup = "WalletTopup",
  RevisionPayment = "RevisionPayment",
  SubscriptionRenewal = "SubscriptionRenewal",
}

// ------------------------------------------------------------
// Payment Return Context
//
// Indicates where the payment was initiated from.
// Used to determine post-payment navigation.
// ------------------------------------------------------------

export enum PaymentReturnContext {
  Checkout = "Checkout",

  UserProfile = "UserProfile",

  OrderRevision = "OrderRevision",

  Subscription = "Subscription",
}
